/* eslint-disable camelcase */
import React from "react";
import { IoIosBoat, IoMdCar } from "react-icons/io";
import { Tool, Truck } from "react-feather";
import { MdOutlineTwoWheeler, MdHandyman } from "react-icons/md";
import { FaTrailer, FaToolbox } from "react-icons/fa";
import {
  boatMakes,
  carMakesByCountry,
  carsMakes,
  heavy_dutyMakes,
  machineryMakes,
  motorcycleMakes,
  trailerMakes,
} from "./vechile-makes";
import { all } from "axios";

export const features = [
  { value: "sunroof", labelKey: "post.features.sunroof" },
  { value: "brakeAssist", labelKey: "post.features.brakeAssist" },
  { value: "keylessEntry", labelKey: "post.features.keylessEntry" },
  { value: "alloyWheels", labelKey: "post.features.alloyWheels" },
  { value: "cruiseControl", labelKey: "post.features.cruiseControl" },
  { value: "leatherSeats", labelKey: "post.features.leatherSeats" },
  { value: "powerDoorLock", labelKey: "post.features.powerDoorLock" },
  { value: "powerMirrors", labelKey: "post.features.powerMirrors" },
  { value: "powerSteering", labelKey: "post.features.powerSteering" },
  { value: "powerWindows", labelKey: "post.features.powerWindows" },
];

export const condition = [
  { value: "new", labelKey: "post.condition.new" },
  { value: "used", labelKey: "post.condition.used" },
];
export const fuels = [
  { value: "diesel", labelKey: "post.fuels.diesel" },
  { value: "gas", labelKey: "post.fuels.gas" },
  { value: "gasoline", labelKey: "post.fuels.gasoline" },
  { value: "electric", labelKey: "post.fuels.electric" },
  { value: "hybrid", labelKey: "post.fuels.hybrid" },
];
export const bodyStyle = [
  { value: "sedan", labelKey: "post.bodyStyles.sedan" },
  { value: "suvs", labelKey: "post.bodyStyles.suvs" },
  { value: "pickup", labelKey: "post.bodyStyles.pickup" },
  { value: "convertible", labelKey: "post.bodyStyles.convertible" },
  { value: "coupe", labelKey: "post.bodyStyles.coupe" },
  { value: "van", labelKey: "post.bodyStyles.van" },
  { value: "hatchback", labelKey: "post.bodyStyles.hatchback" },
  { value: "minivan", labelKey: "post.bodyStyles.minivan" },
  { value: "other", labelKey: "post.bodyStyles.other" },
];

export const titles = [
  { value: "clean", labelKey: "post.titles.clean" },
  { value: "rebuilt", labelKey: "post.titles.rebuilt" },
  { value: "salvage", labelKey: "post.titles.salvage" },
  { value: "lien", labelKey: "post.titles.lien" },
  { value: "parts", labelKey: "post.titles.parts" },
  { value: "flood", labelKey: "post.titles.flood" },
  { value: "others", labelKey: "post.titles.others" },
];
export const soat = [
  { value: "conSoat", labelKey: "post.soat.conSoat" },
  { value: "sinSoat", labelKey: "post.soat.sinSoat" },
  { value: "conVerificacionV.", labelKey: "post.soat.conVerificacionV." },
  { value: "sinVerificacionV.", labelKey: "post.soat.sinVerificacionV." },
];
const titlesRest = titles.slice(2);

export const titlesByCountry = {
  US: [...titles],
};
export const soatByCountry = {
  PE: [
    { value: "conSoat", labelKey: "post.soat.conSoat" },
    { value: "sinSoat", labelKey: "post.soat.sinSoat" },
  ],
  MX: [
    { value: "conVerificacionV.", labelKey: "post.soat.conVerificacionV." },
    { value: "sinVerificacionV.", labelKey: "post.soat.sinVerificacionV." },
  ],
};
export const getSoatByCountry = (code) => soatByCountry[code];
export const getTitlesByCountry = (code) => titlesByCountry[code] || titles;

export const transmission = [
  { value: "auto", labelKey: "post.transmission.auto" },
  { value: "manual", labelKey: "post.transmission.manual" },
  { value: "semiAuto", labelKey: "post.transmission.semiAuto" },
];

export const currencies = {
  MX: [{ value: "dollars", labelKey: "post.currency.dollars", symbol: "$" }],
  US: [{ value: "dollars", labelKey: "post.currency.dollars", symbol: "$" }],
  PE: [
    { value: "sol", labelKey: "post.currency.sol", symbol: "S/" },
    { value: "dollars", labelKey: "post.currency.dollars", symbol: "$" },
  ],
};
export const getCurrency = (code) => currencies[code] || currencies.US;

export const postCategories = [
  {
    id: "cars",
    title: "static.categories.cars",
    slugs: ["car", "truck", "van", "sports", "racing"],
    icon: <IoMdCar size={70} color="#F5F5F5" />,
  },
  {
    id: "heavy_duty",
    title: "static.categories.heavyDuty",
    slugs: ["trucks", "jeep"],
    icon: <Truck size={60} color="#F5F5F5" />,
  },
  {
    id: "motorcycle",
    title: "static.categories.motorcycle",
    slugs: ["bike", "bikes", "dirt", "touring", "racing"],
    icon: <MdOutlineTwoWheeler size={60} color="#F5F5F5" />,
  },
  {
    id: "boat",
    title: "static.categories.boats",
    slugs: ["boat", "boats", "yacht", "cruise", "jet ski", "sail boat"],
    icon: <IoIosBoat size={60} color="#F5F5F5" />,
  },
  {
    id: "trailer",
    title: "static.categories.trailers",
    slugs: ["van", "trailer"],
    icon: <FaTrailer size={60} color="#F5F5F5" />,
  },
  {
    id: "machinery",
    title: "static.categories.machinery",
    slugs: ["machinery"],
    icon: <Tool size={50} color="#F5F5F5" />,
  },
  {
    id: "other",
    title: "static.categories.others",
    slugs: [],
    icon: <FaToolbox size={50} color="#F5F5F5" />,
  },
  {
    id: "part",
    title: "static.categories.parts",
    slugs: [],
    icon: <MdHandyman size={50} color="#F5F5F5" />,
  },
];
export const fieldsType = [
  { name: "titleVehicle", type: "text", required: false },
  { name: "make", type: "modal", required: true },
  { name: "model", type: "text", required: true },
  { name: "year", type: "number", required: true },
  { name: "miles", type: "number", required: false },
  { name: "currency", type: "select", required: true },
  { name: "price", type: "number", required: true },
  { name: "condition", type: "select", required: false },
  { name: "bodyStyle", type: "select", required: true },
  { name: "fuel", type: "select", required: false },
  { name: "title", type: "select", required: false },
  { name: "soat", type: "select", required: true },
  { name: "features", type: "checkbox", required: false },
  { name: "transmission", type: "select", required: false },
  { name: "description", type: "textarea", required: false },
];

export const postFormData = {
  cars: [
    {
      label: "static.fieldsType.titleVehicle",
      name: "titleVehicle",
      type: "text",
      placeholder: "static.placeholders.vehicleExample",
    },
    {
      label: "static.fieldsType.make",
      name: "make",
      type: "modal",
      isMultiSelect: false,
      data: carMakesByCountry,
    },
    {
      label: "static.fieldsType.model",
      name: "model",
      type: "text",
      isMultiSelect: false,
      data: {},
    },
    {
      label: "static.fieldsType.year",
      name: "year",
      type: "number",
      mask: [/\d/, /\d/, /\d/, /\d/],
    },
    {
      label: "static.fieldsType.currency",
      name: "currency",
      type: "select",
      data: currencies,
    },
    {
      label: "static.fieldsType.price",
      name: "price",
      type: "number",
    },

    {
      label: "static.fieldsType.title",
      name: "title",
      type: "select",
      data: titles,
    },
    {
      label: "static.fieldsType.soat",
      name: "soat",
      type: "select",
      data: soat,
    },
    {
      label: "static.fieldsType.miles",
      name: "miles",
      type: "number",
    },
    {
      label: "static.fieldsType.engine",
      name: "engine",
      type: "text",
    },
    {
      label: "static.fieldsType.condition",
      isMultiSelect: false,
      name: "condition",
      type: "select",

      data: condition,
    },
    {
      label: "static.fieldsType.features",
      name: "features",
      type: "select",
      isMultiSelect: true,
      data: features,
    },

    {
      label: "static.fieldsType.bodyStyle",
      name: "bodyStyle",
      type: "select",

      data: bodyStyle,
    },
    {
      label: "static.fieldsType.fuel",
      name: "fuel",
      type: "select",
      data: fuels,
    },
    {
      label: "static.fieldsType.transmission",
      name: "transmission",
      type: "select",
      data: transmission,
    },
    {
      label: "static.fieldsType.description",
      name: "description",
      type: "textArea",
    },
  ],
  heavy_duty: [
    {
      label: "static.fieldsType.titleVehicle",
      name: "titleVehicle",
      type: "text",
      placeholder: "static.placeholders.vehicleExample",
    },
    {
      label: "static.fieldsType.make",
      name: "make",
      type: "modal",

      isMultiSelect: false,
      data: heavy_dutyMakes,
    },
    {
      label: "static.fieldsType.model",
      name: "model",
      type: "text",
      data: {},
    },
    {
      label: "static.fieldsType.year",
      name: "year",
      type: "number",
      mask: [/\d/, /\d/, /\d/, /\d/],
    },

    {
      label: "static.fieldsType.currency",
      name: "currency",
      type: "select",
      data: currencies,
    },
    {
      label: "static.fieldsType.price",
      name: "price",
      type: "number",
    },
    {
      label: "static.fieldsType.title",
      name: "title",
      type: "select",
      data: titles,
    },
    {
      label: "static.fieldsType.miles",
      name: "miles",
      type: "number",
    },
    {
      label: "static.fieldsType.engine",
      name: "engine",
      type: "text",
    },
    {
      label: "static.fieldsType.condition",
      isMultiSelect: false,
      name: "condition",
      type: "select",

      data: condition,
    },
    {
      label: "static.fieldsType.fuel",
      name: "fuel",
      type: "modal",

      data: fuels,
    },
    {
      label: "static.fieldsType.transmission",
      name: "transmission",
      type: "modal",

      data: [
        "post.transmission.auto",
        "post.transmission.manual",
        "post.transmission.semiAuto",
      ],
    },
    {
      label: "static.fieldsType.description",
      name: "description",
      type: "textArea",
    },
  ],
  motorcycle: [
    {
      label: "static.fieldsType.titleVehicle",
      name: "titleVehicle",
      type: "text",
      placeholder: "static.placeholders.vehicleExample",
    },
    {
      label: "static.fieldsType.make",
      name: "make",
      type: "modal",

      isMultiSelect: false,
      data: motorcycleMakes,
    },
    {
      label: "static.fieldsType.model",
      name: "model",
      type: "text",
      data: {
        bmw: [],
        camAm: [],
        ducati: [],
        harleyDavidson: [],
        honda: [],
        husqvarna: [],
        indian: [],
        kawasaki: [],
        ktm: [],
        slingshot: [],
        ssrMotorsports: [],
        suzuki: [],
        triumph: [],
        vespa: [],
        yamaha: [],
      },
    },
    {
      label: "static.fieldsType.year",
      name: "year",
      type: "number",
      mask: [/\d/, /\d/, /\d/, /\d/],
    },
    {
      label: "static.fieldsType.currency",
      name: "currency",
      type: "select",
      data: currencies,
    },
    {
      label: "static.fieldsType.price",
      name: "price",
      type: "number",
    },
    {
      label: "static.fieldsType.title",
      name: "title",
      type: "select",
      data: titles,
    },
    {
      label: "static.fieldsType.miles",
      name: "miles",
      type: "number",
    },
    {
      label: "static.fieldsType.engine",
      name: "engine",
      type: "text",
    },
    {
      label: "static.fieldsType.fuel",
      name: "fuel",
      type: "modal",

      data: fuels,
    },
    {
      label: "static.fieldsType.condition",
      isMultiSelect: false,
      name: "condition",
      type: "modal",

      data: condition,
    },
    {
      label: "static.fieldsType.description",
      name: "description",
      type: "textArea",
    },
  ],
  boat: [
    {
      label: "static.fieldsType.titleVehicle",
      name: "titleVehicle",
      type: "text",
      placeholder: "static.placeholders.vehicleExample",
    },
    {
      label: "static.fieldsType.make",
      name: "make",
      type: "modal",

      isMultiSelect: false,
      data: boatMakes,
    },
    {
      label: "static.fieldsType.model",
      name: "model",
      type: "text",
      data: {
        bayliner: [],
        bertram: [],
        beneteau: [],
        carver: [],
        chaparral: [],
        chrisCraft: [],
        formula: [],
        gradyWhite: [],
        hatterasYachts: [],
        hunterMarine: [],
        regal: [],
        seaRay: [],
        silverton: [],
        sunseeker: [],
        wellcraft: [],
      },
    },
    {
      label: "static.fieldsType.length",
      name: "length",
      type: "number",
    },
    {
      label: "static.fieldsType.year",
      name: "year",
      type: "number",
      mask: [/\d/, /\d/, /\d/, /\d/],
    },
    {
      label: "static.fieldsType.currency",
      name: "currency",
      type: "select",
      data: currencies,
    },
    {
      label: "static.fieldsType.price",
      name: "price",
      type: "number",
    },
    {
      label: "static.fieldsType.title",
      name: "title",
      type: "modal",
      data: titles,
    },
    {
      label: "static.fieldsType.hours",
      name: "hours",
      type: "number",
    },
    {
      label: "static.fieldsType.engine",
      name: "engine",
      type: "text",
    },
    {
      label: "static.fieldsType.condition",
      isMultiSelect: false,
      name: "condition",
      type: "modal",

      data: condition,
    },
    {
      label: "static.fieldsType.description",
      name: "description",
      type: "textArea",
    },
  ],
  machinery: [
    {
      label: "static.fieldsType.titleVehicle",
      name: "titleVehicle",
      type: "text",
      placeholder: "static.placeholders.vehicleExample",
    },
    {
      label: "static.fieldsType.make",
      name: "make",
      type: "modal",

      isMultiSelect: false,
      data: machineryMakes,
    },
    {
      label: "static.fieldsType.model",
      name: "model",
      type: "text",
      data: {
        bmw: [],
        camAm: [],
        ducati: [],
        harleyDavidson: [],
        honda: [],
        husqvarna: [],
        indian: [],
        kawasaki: [],
        ktm: [],
        slingshot: [],
        ssrMotorsports: [],
        suzuki: [],
        triumph: [],
        vespa: [],
        yamaha: [],
      },
    },
    {
      label: "static.fieldsType.year",
      name: "year",
      type: "number",
      mask: [/\d/, /\d/, /\d/, /\d/],
    },
    {
      label: "static.fieldsType.currency",
      name: "currency",
      type: "select",
      data: currencies,
    },
    {
      label: "static.fieldsType.price",
      name: "price",
      type: "number",
    },
    {
      label: "static.fieldsType.title",
      name: "title",
      type: "modal",
      data: titles,
    },
    {
      label: "static.fieldsType.length",
      name: "length",
      type: "number",
    },
    {
      label: "static.fieldsType.hours",
      name: "hours",
      type: "number",
    },
    {
      label: "static.fieldsType.engine",
      name: "engine",
      type: "text",
    },
    {
      label: "static.fieldsType.condition",
      isMultiSelect: false,
      name: "condition",
      type: "modal",

      data: condition,
    },
    {
      label: "static.fieldsType.description",
      name: "description",
      type: "textArea",
    },
  ],
  trailer: [
    {
      label: "static.fieldsType.titleVehicle",
      name: "titleVehicle",
      type: "text",
      placeholder: "static.placeholders.vehicleExample",
    },
    {
      label: "static.fieldsType.make",
      name: "make",
      type: "modal",

      isMultiSelect: false,
      data: trailerMakes,
    },
    {
      label: "static.fieldsType.model",
      name: "model",
      type: "text",
      data: {
        eastManufacturing: [],
        greatdane: [],
        hyundai: [],
        utility: [],
        vanguardNational: [],
        wabash: [],
        doepkerIndustries: [],
        fellingTrailers: [],
        fontaineTrailer: [],
        frehauf: [],
        heilTrailer: [],
        kentucky: [],
        macTrailer: [],
        manac: [],
        pitts: [],
      },
    },
    {
      label: "static.fieldsType.year",
      name: "year",
      type: "number",
      mask: [/\d/, /\d/, /\d/, /\d/],
    },
    {
      label: "static.fieldsType.currency",
      name: "currency",
      type: "select",
      data: currencies,
    },
    {
      label: "static.fieldsType.price",
      name: "price",
      type: "number",
    },
    {
      label: "static.fieldsType.title",
      name: "title",
      type: "modal",
      data: titles,
    },
    {
      label: "static.fieldsType.length",
      name: "length",
      type: "number",
    },
    {
      label: "static.fieldsType.hours",
      name: "hours",
      type: "number",
    },
    {
      label: "static.fieldsType.engine",
      name: "engine",
      type: "text",
    },
    {
      label: "static.fieldsType.condition",
      isMultiSelect: false,
      name: "condition",
      type: "modal",

      data: condition,
    },
    {
      label: "static.fieldsType.description",
      name: "description",
      type: "textArea",
    },
  ],
  part: [
    {
      label: "static.fieldsType.vehicleParts",
      name: "parts",
      type: "modal",
      data: [
        "All",
        "Electric Parts",
        "Engine Parts",
        "Body Parts",
        "Interior Parts",
        "Accessories",
        "Other",
      ],
    },
    {
      label: "static.fieldsType.titlePart",
      name: "titleVehicle",
      type: "text",
    },
    {
      label: "static.fieldsType.condition",
      isMultiSelect: false,
      name: "condition",
      type: "modal",
      data: condition,
    },
    {
      label: "static.fieldsType.currency",
      name: "currency",
      type: "select",
      data: currencies,
    },
    {
      label: "static.fieldsType.price",
      name: "price",
      type: "number",
    },
    {
      label: "static.fieldsType.description",
      name: "description",
      type: "textArea",
    },
  ],
  other: [
    {
      label: "static.fieldsType.vehicleTypes",
      name: "parts",
      type: "modal",
      data: [
        "All",
        "Bus",
        "Jet Ski",
        "Recreational Vehicle",
        "Snow Mobile",
        "Industrial",
        "Off-Road",
        "Scooter",
        "Bicycle",
        "Other",
      ],
    },
    {
      label: "static.fieldsType.titleVehicle",
      name: "titleVehicle",
      type: "text",
      placeholder: "static.placeholders.vehicleExample",
    },
    {
      label: "static.fieldsType.condition",
      isMultiSelect: false,
      name: "condition",
      type: "modal",

      data: condition,
    },
    {
      label: "static.fieldsType.year",
      name: "year",
      type: "number",
      mask: [/\d/, /\d/, /\d/, /\d/],
    },
    {
      label: "static.fieldsType.currency",
      name: "currency",
      type: "select",
      data: currencies,
    },
    {
      label: "static.fieldsType.price",
      name: "price",
      type: "number",
    },
    {
      label: "static.fieldsType.title",
      name: "title",
      type: "modal",
      data: titles,
    },
    {
      label: "static.fieldsType.description",
      name: "description",
      type: "textArea",
    },
  ],
};
